export type actionModalSelect = 'agregar' | 'actualizar' | 'eliminar';

export class ColumnsTableModalSelect {
  key: string;
  label: string;
  type?: string;
  category?: string;
  view?: boolean;
  columnsDependence?: ColumnsTableModalSelect[];
  alias?: string;
}

export class AccionModal {
  temporalData: any;
  registroSeleccionado?: any;
  accion: actionModalSelect;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/modal-select.model.ts